export const BANKER_CARD = 1;
export const PLAYER_CARD = 2;
